import React from "react"
import { connect } from 'react-redux'
import ConfirmationPopover from '../../../components/ConfirmationPopover'
import { Form } from 'react-bootstrap'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import { userRegionIsEU } from '../../../functions/userPermissions'
import { setCustomSusceptibilityTestWarning } from '../reducers/infectionCourseFormReducer'

const SusceptibilityTestRow = (props) => {

  const {
    susceptibilityTest,
    micOrZoneOptions,
    interpretationOptions,
    chartForReview,
    patchSusceptibilityTest,
    susceptibilityDrugOptions,
    handleSusceptibilityTestBlur,
    // getInterpretationValue,
    handleRemoveSusceptibilityTest,
    currentUser,
    pathogen,
    site,
  } = props

  const susceptibilityTestRadioName = `${site.name}-${site.id}-${pathogen.name}-${pathogen.id}-${susceptibilityTest.drug_name}`

  const micOrZoneIsRequired = (susTest) => {
    // const interpretationValue = getInterpretationValue(susceptibilityTest.drug_name)
    if (susceptibilityTest.interpretation === 'NI') {
      return !susTest.zone && !susTest.mic && !susTest.mic_and_zone_not_available
    }
    return !susTest.zone && !susTest.mic
  }
  
  const usInterpretationOptions = [
    { displayName: 'CLSI', fieldName: 'clsi' },
    { displayName: 'FDA', fieldName: 'fda' },
    { displayName: "Don't Know", fieldName: 'breakpoint_interpretation_unknown' },
  ]
  
  const euInterpretationOptions = [
    { displayName: 'EUCAST ', fieldName: 'eu_cast' },
    { displayName: 'CLSI', fieldName: 'clsi' },
    { displayName: "Don't Know", fieldName: 'breakpoint_interpretation_unknown' },
  ]

  const getInterpretationOptions = () => {
    if (userRegionIsEU(currentUser)) {
      return euInterpretationOptions
    }
    return usInterpretationOptions
  }


  const handleSusceptibilityBreakpointChange = (e) => {
    const fieldName = e.target.value
    const updatedSusceptibilityTest = {
      ...susceptibilityTest,
      clsi: false,
      fda: false,
      eu_cast: false,
      breakpoint_interpretation_unknown: false,
      [fieldName]: true,
    }
    patchSusceptibilityTest(true, fieldName, updatedSusceptibilityTest)
    handleSusceptibilityTestBlur(updatedSusceptibilityTest, pathogen)
  }

  const handleMicOrZoneNotDone = () => {
    const micOrZoneNotDone = !susceptibilityTest.mic_and_zone_not_available
    const updatedSusceptibilityTest = {
      ...susceptibilityTest,
      mic_and_zone_not_available: micOrZoneNotDone,
      clsi: false,
      fda: false,
      eu_cast: false,
      test_not_done: false,
      mic: '',
      zone: '',
    }

    patchSusceptibilityTest(micOrZoneNotDone, 'mic_and_zone_not_available', updatedSusceptibilityTest)
    // const additionalFields = ['clsi', 'fda', 'eu_cast', 'mic', 'zone']
    // additionalFields.forEach(field => {
    //   if (props.susceptibilityTest[field] === true) {
    //     patchSusceptibilityTest(false, field, susceptibilityTest)
    //   } else if (!!props.susceptibilityTest[field]) {
    //     patchSusceptibilityTest('', field, susceptibilityTest)
    //   }
    // })
    handleSusceptibilityTestBlur(updatedSusceptibilityTest, pathogen)
  }


  const handleInterpretationChange = (e) => {
    let updatedSusceptibilityTest = { ...susceptibilityTest, interpretation: e.target.value }
    if (susceptibilityTest.mic_and_zone_not_available || (e.target.value === 'NI' && susceptibilityTest.interpretation !== 'NI')) {
      // handleMicOrZoneNotDone()
      updatedSusceptibilityTest = {
        ...updatedSusceptibilityTest,
        interpretation: e.target.value,
        mic_and_zone_not_available: false,
        clsi: false,
        fda: false,
        eu_cast: false,
        test_not_done: false,
        breakpoint_interpretation_unknown: false,
        mic: '',
        zone: '',
      }
    }
    patchSusceptibilityTest(e.target.value, 'interpretation', updatedSusceptibilityTest)
    handleSusceptibilityTestBlur(updatedSusceptibilityTest, pathogen)
  }


  const getBreakpointOptionsRequired = () => {
    if (!susceptibilityTest) {
      return false
    }
    if (susceptibilityTest.interpretation !== 'NI') {
      const options = getInterpretationOptions()
      return !options.find(option => susceptibilityTest[option.fieldName] === true)
    }
    return false
  }

  const handleRemove = () => {
    return handleRemoveSusceptibilityTest(susceptibilityTest)
  }

  const popoverContent = () => {
    return (
      <div>
        <p>Remove <strong>{susceptibilityTest.drug_name}</strong>?</p>
        <br/>
        <p>
          This action will <strong> delete the Susceptibility Test instance from the database</strong>.
        </p>
      </div>
    )
  }

  const handleTestNotDoneChange = () => {
    const updatedSusceptibilityTest = {
      ...susceptibilityTest, 
      test_not_done: !susceptibilityTest.test_not_done,
      interpretation: '',
      mic: '',
      zone: '',
      clsi: false,
      fda: false,
      eu_cast: false,
      breakpoint_interpretation_unknown: false,
      mic_and_zone_not_available: false,
    }
    
    patchSusceptibilityTest(!susceptibilityTest.test_not_done, 'test_not_done', updatedSusceptibilityTest)
    
    handleSusceptibilityTestBlur(updatedSusceptibilityTest, pathogen)
  }

  const rowDisabled = chartForReview || 
    (susceptibilityTest.drug_name === 'Cefiderocol' && susceptibilityTest.test_not_done === true)

  return (
    <tr key={susceptibilityTest.id}>
        <td className='form-input-td'>
          {chartForReview || susceptibilityTest.drug_name.toLowerCase() === 'cefiderocol' ?
            null
            :
              <center>
                <ConfirmationPopover
                  triggerText='x'
                  title='Delete Row?'
                  placement='right'
                  popoverContent={popoverContent(susceptibilityTest)}
                  onConfirm={handleRemove}
                />
              </center>
          }
          {susceptibilityTest.drug_name.toLowerCase() === 'cefiderocol' ?
            
              <center>
                <Form.Label htmlFor={susceptibilityTest.url}>
                  Test Not Done
                </Form.Label>
                <br />
                <Form.Check
                  id={susceptibilityTest.url}
                  checked={susceptibilityTest.test_not_done === true}
                  onChange={() => handleTestNotDoneChange()}
                  disabled={chartForReview}
                />
              </center>
            
            :
            null
          }
        </td>


      {susceptibilityDrugOptions.includes(susceptibilityTest.drug_name) || chartForReview ?
        <td>
          {susceptibilityTest.drug_name}
        </td>
        :
        <td>
          <Form.Group>
            <Form.Label>
              Enter drug Name:
            </Form.Label>
            <Form.Control
              label={''}
              type={'text'}
              name={'drug_name'}
              value={susceptibilityTest.drug_name}
              onChange={() => null}
              disabled={chartForReview}
              required={true}
              onClick={
                chartForReview ? 
                () => null 
                :
                () => props.handleShowCustomOptionModal(susceptibilityTest)
              }
            />
          </Form.Group>
        </td>
      }

      <td>
        <SelectWithOptionalTextField
          className="wide"
          label=''
          options={interpretationOptions}
          selectFieldName='interpretation'
          selected={susceptibilityTest.interpretation || ''}
          handleChange={handleInterpretationChange}
          disabled={rowDisabled}
          // onBlur={() => handleSusceptibilityTestBlur(susceptibilityTest, pathogen)}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />
      </td>

      <td>
        {micOrZoneOptions.map(option => {
          return (
            <Form.Group key={option.displayName}>
              <Form.Label>
                {option.displayName}
              </Form.Label>
              <Form.Control
                label={option.displayName}
                type={'text'}
                name={option.fieldName}
                style={{ margin: '0% 2% 2% 0%'}}
                value={susceptibilityTest[option.fieldName] || ''}
                onChange={(e) => patchSusceptibilityTest(e.target.value, e.target.name, susceptibilityTest)}
                disabled={chartForReview || susceptibilityTest.mic_and_zone_not_available === true || susceptibilityTest.test_not_done === true}
                onBlur={() => handleSusceptibilityTestBlur(susceptibilityTest, pathogen)}
                required={micOrZoneIsRequired(susceptibilityTest)}
              />
            </Form.Group>
          )
        })}

        {susceptibilityTest.drug_name === 'Cefiderocol' && susceptibilityTest.interpretation === 'NI' ?
          <Form.Group>
            <Form.Check
              id={`${susceptibilityTestRadioName}-mic_and_zone_not_available`}
              name={`${susceptibilityTestRadioName}-mic_and_zone_not_available`}
              label="MIC and Zone size not available"
              value={susceptibilityTest.mic_and_zone_not_available}
              checked={susceptibilityTest.mic_and_zone_not_available}
              onChange={handleMicOrZoneNotDone}
              disabled={rowDisabled}
              required={micOrZoneIsRequired(susceptibilityTest)}
            />
          </Form.Group>
          :
          null
        }


        {
          susceptibilityTest.drug_name === 'Cefiderocol' && susceptibilityTest.interpretation !== 'NI'
          ?
            <Form.Group>
              <Form.Label>
                Breakpoint used for interpretation:
              </Form.Label>
              {getInterpretationOptions().map((option, idx) => {
                return (
                  <div style={{marginLeft: '20px'}} key={`interpretation-option-${option.fieldName}${idx}`}>
                    <Form.Check
                      key={`${susceptibilityTestRadioName}-${option.fieldName}`}
                      id={`${susceptibilityTestRadioName}-${option.fieldName}`}
                      type="radio"
                      name={`${susceptibilityTestRadioName}-${option.fieldName}`}
                      label={option.displayName}
                      checked={susceptibilityTest[`${option.fieldName}`] === true}
                      value={option.fieldName}
                      onChange={handleSusceptibilityBreakpointChange}
                      disabled={rowDisabled}
                      required={getBreakpointOptionsRequired()}
                    />
                  </div>
                )
              })}
            </Form.Group>
          :
            null
        }
      </td>
    </tr>
  )
}

const mapStateToProps = (state) => {
  return {
    showWarning: state.infectionCourseFormReducer.showCustomSusceptibilityTestWarning,
    warningMessage: state.infectionCourseFormReducer.customSusceptibilityTestWarningMessage,
  }
}
export default connect(mapStateToProps, { setCustomSusceptibilityTestWarning })(SusceptibilityTestRow)
